import { ChangeDetectionStrategy, Component, Injector, OnInit, ViewEncapsulation } from '@angular/core';
import { TabsModuleBase } from '../utilities/tabs/tabs-module-base';
import { FiStateNames } from '../shared/fi-state-proxy/fi-state-names';
import { AppTextService } from '../shared/app-text';
import { FiCustomerDataService } from '../shared/fi-shared-services/fi-customer-data.service';

@Component({
    selector: 'fi-translation-navigation-tabs',
    template: `
        <fi-navigation-tabs
            [tabsModel]="tabs"
            [selectedIndex]="selectedIndex"
            (selectedIndexChange)="onTabIndexChange($event)"
        >
        </fi-navigation-tabs>
    `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-translation-navigation-tabs' },
    standalone: false,
})
export class FiTranslationNavigationTabsComponent extends TabsModuleBase implements OnInit {
    constructor(
        private appTextService: AppTextService,
        private customerDataService: FiCustomerDataService,
        injector: Injector,
    ) {
        super(injector);
    }

    ngOnInit(): void {
        if (this.customerDataService.isTestCustomer()) {
            this.tabs.push({
                Title: this.appTextService.get('translation.edit_labels'),
                Sref: FiStateNames.Translation.List,
            });
        }

        super.updateSelectedTabFromState();
    }
}
